import * as React from 'react'
import { Label as LabelPrimitive } from 'radix-ui'

import { cn } from '../utils'

function Label({
  className,
  isRequired,
  children,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & {
  isRequired?: boolean
}) {
  return (
    <LabelPrimitive.Root
      data-slot='label'
      className={cn(
        'text-sm font-semibold group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-default peer-disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
      {isRequired && <span className='text-destructive ml-1'>*</span>}
    </LabelPrimitive.Root>
  )
}

export { Label }
